import { NATIVE_ADDRESS } from "@/constants/addresses";
import { STORAGE_KEYS, getStorageKey } from "@/libs/Storage";
import { useMemo } from "react";
import { useLocalStorage } from "usehooks-ts";
import { useAccount } from "@/hooks/useAccount";

export const useJwtStorage = () => {
  const { address, chain } = useAccount();

  const storageKey = useMemo(
    () => getStorageKey(chain?.id, address ?? NATIVE_ADDRESS, STORAGE_KEYS.JWT),
    [address, chain?.id]
  );

  const [jwt, setJwt, removeJwt] = useLocalStorage<string | undefined>(
    storageKey,
    undefined
  );

  return {
    jwt,
    setJwt,
    removeJwt,
  };
};
